import classNames from "classnames";
import React, { useCallback } from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import PlusIcon from "../../icons/PlusIcon";
import { SanityCallout } from "../../model/common";
import { createLinkTo } from "../../utils/links";
import { imageUrlBuilder } from "../../utils/images";
import Link from "../Link/Link";
import Text from "../Text/Text";
import styles from "./Callout.module.scss";

export interface CalloutProps {
  node: SanityCallout;
  className?: string;
}

const Callout = ({
  node: { title, subtitle, icon, callToAction },
  className
}: CalloutProps) => {
  const targetModal = callToAction?.targetModal;
  const language = useLanguage();
  const to = createLinkTo(callToAction, language);

  const handleClick = useCallback(() => {
    if (targetModal) {
      window.dispatchEvent(
        new CustomEvent("openmodal", {
          detail: {
            id: targetModal
          }
        })
      );
    }
  }, [targetModal]);

  const calloutContent = (
    <>
      {icon && (
        <img
          className={styles.icon}
          alt={icon.alt}
          width={50}
          src={
            imageUrlBuilder
              .image(icon.asset)
              .width(100)
              .url()!
          }
        />
      )}
      <div className={styles.text}>
        <Text className={styles.title} variant="defaultBold">
          {title}
        </Text>
        {subtitle && <Text variant="default">{subtitle}</Text>}
      </div>
      <div className={styles.ctaIconButton}>
        <PlusIcon />
      </div>
    </>
  );

  return (
    <>
      {to ? (
        <Link className={classNames(styles.root, className)} to={to}>
          {calloutContent}
        </Link>
      ) : (
        <button
          className={classNames(styles.root, className)}
          onClick={handleClick}
        >
          {calloutContent}
        </button>
      )}
    </>
  );
};

export default Callout;
